import React, { useMemo } from 'react';
import classnames from 'classnames';
import shortid from 'shortid';
import { castArray, isNil, slice, noop, size, isEmpty, get, isArray } from 'lodash';
import ReactTooltip from 'react-tooltip';

// local dependencies
import { textWithPatternMatch } from 'utils/textWithPatternMatch';
import { DATA_TYPES } from 'constants/common';
import { Tooltip } from 'modules/tooltip';
import { getDisplayValue } from 'resolvers/formatValue';
import { Icon } from 'modules/icon-bank';
import { entityConfig } from 'config/entity-info/prior-auth-summary.js';

/**
 * @desc Data cell view for single or mult-select data cells.
 * @example
 * import { simpleText as SimpleTextCellView } from './cellViews/simpleText.view';
 */
export const simpleText = ( props ) => {

    // get proper display value
    const value = getDisplayValue( { type: props.columnType, value: props.value } ); // includes( DATA_TYPES.CURRENCY, props.columnType ) ? `$${ props.value }` : props.value;

    // extract display values and field values
    const displayValues = castArray( value );

    // get visible display values based on `maxDisplayValues`
    const isValueTruncated = ! isNil( props.maxDisplayValues ) && ( 1 < size( displayValues ) );
    const visibleDisplayValues = isValueTruncated ? slice( displayValues, 0, props.maxDisplayValues ) : displayValues;
    
    // dynamic class name
    const widgetClassName = classnames( 'ui-table-cell-view-simple-text', props.className, {
        'ui-table-cell-view-simple-text--truncated': isValueTruncated,
        'ui-table-cell-view-simple-text--actionable': props.isActionable,
    } );
   // const statushold = props.item.values.accountStatus === "hold";
    const statusinactive = props.item.values.accountStatus === "inactive";

    // item class name
    const itemClassName = classnames( 'ui-table-cell-view-simple-text__display-values__items__item', {
        'ui-table-cell-view-simple-text__display-values__items__item--red-text': props.shouldTextBeRed,
        'ui-table-cell-view-simple-text__display-values__items__item--blue-text': props.shouldTextBeBlue
    } );

    const InactiveClassName = classnames( 'ui-table-cell-view-simple-text__display-values__items__item', {
        'ui-table-cell-view-simple-text__display-values__items__itemInactive': statusinactive,
        
    } );

    // tooltip class names
     const tooltipClassNames = classnames( 'ui-table-cell-view-simple-text__display-values__icon__tooltip', {
        'ui-table-cell-view-simple-text__display-values__icon__tooltip__custom': props.addTooltipCustomClass
    } );

    // unique id
    const uniqId = useMemo( shortid.generate, [] );

    return (
        <div className={ widgetClassName }>
            {/* display values */}
            <div className='ui-table-cell-view-simple-text__display-values' onClick={ props.onClick }>
                {/* items */}
                <div className='ui-table-cell-view-simple-text__display-values__items'>
                    {
                        visibleDisplayValues.map( ( visibleDisplayValue, index ) => {
                            const columnName = get( props, 'column.name', '' );
                            const valueColor = get( entityConfig, `valueColors.${ columnName }.${ visibleDisplayValue }`, undefined );

                            return (
                                
                                // <Tooltip
                                //     key={ `${index}-${columnName}` }
                                //     text={ visibleDisplayValue }
                                //     active={ ! isValueTruncated }
                                //     activateOnOverflow={ true }
                                //     render={ ( binding = {} ) => (
                                //         <div
                                //         key= { `${index}-${columnName}`}
                                //         id={ `${index}-${columnName}`}
                                //             { ...binding }
                                //             className={ `${itemClassName} ${InactiveClassName}` }
                                //             style= { { color: valueColor } }
                                            
                                //             { ...( isValueTruncated ? { 'data-tip': 'true', 'data-for': uniqId } : {} ) }
                                //         >
                                //              { props.isSearchable ? textWithPatternMatch( {
                                //                 value: visibleDisplayValue,
                                //                 pattern: props.searchQuery,
                                //                 wildcard: true,
                                //                 type: props.columnType,
                                //             } ) : visibleDisplayValue }
                                //             </div>
                                //     ) }
                                // />
                                <Tooltip
                                key={ index }
                                text={ visibleDisplayValue }
                                active={ ! isValueTruncated }
                                activateOnOverflow={ true }
                                render={ ( binding = {} ) => (
                                    <div
                                        { ...binding }
                                        className={ `${itemClassName} ${InactiveClassName}`}
                                        style= { { color: valueColor } }
                                        dangerouslySetInnerHTML={ { __html: props.isSearchable ? textWithPatternMatch( {
                                            value: visibleDisplayValue,
                                            pattern: props.searchQuery,
                                            wildcard: true,
                                            type: props.columnType,
                                        } ) : visibleDisplayValue } }
                                        { ...( isValueTruncated ? { 'data-tip': 'true', 'data-for': uniqId } : {} ) }
                                    />
                                ) }
                            />
                            );
                        } )
                    }
                </div>

                {/* icon */}
                {
                    isEmpty( props.icon ) ? null : (
                        <div className='ui-table-cell-view-simple-text__display-values__icon'>
                            <ReactTooltip
                                id={ `${ props.itemId ? props.itemId : props.item.id }-${props.column?.name}-${ props.columnType }-tooltip` }
                                aria-haspopup='true'
                                textColor= { props.tooltipTextColor ? props.tooltipTextColor : '#000' }
                                backgroundColor= { props.tooltipBackgroundColor ? props.tooltipBackgroundColor : '#cdd7e1' }
                                className= { tooltipClassNames }
                                place="bottom"
                            > { isArray( props.tooltipMessage) ?
                                <div>
                              {  props.tooltipMessage.map( (obj,index) => {return <li
                            key={`${index}-${obj}`}>
                            {obj}
                            </li>}  )}</div> : <div>{ props.tooltipMessage }</div> } </ReactTooltip>

                            <div data-tip  data-for={ `${ props.itemId ? props.itemId : props.item.id }-${props.column?.name}-${ props.columnType }-tooltip` } data-place="bottom">
                                <Icon name={ props.icon } width={ 16 } height={ 16 } fill={ THEME.themeColorPrimary2 } />
                            </div>
                        </div>
                    )
                }

                {/* if cell is editable */}
                {
                    props.isCellEditable ? (
                        <div
                            className={ 'ui-table-cell-view-simple-text__display-values__edit-icon' }
                            onClick={ () => props.onEditActionClick( { type: 'cell', value: props.column, item: props.item } ) }
                        >
                            <Icon name='edit' width='14' height='14' />
                        </div>
                    ) : null
                }


                {/* plus button */}
                {
                    isValueTruncated ? (
                        <div
                            className='ui-table-cell-view-simple-text__display-values__plus-button'
                            { ...( isValueTruncated ? { 'data-tip': 'true', 'data-for': uniqId } : {} ) }
                        >
                            +{ size( displayValues ) - 1 }
                        </div>
                    ) : null
                }
            </div>
            

            {/* tooltip */}
            {
                isValueTruncated ? (
                    <ReactTooltip
                        id={ uniqId }
                        aria-haspopup='true'
                        delayShow={ 300 }
                        className='ui-table-cell-view-simple-select__tooltip'
                        backgroundColor={ '#cdd7e1' }
                    >
                        {
                            displayValues.map( ( _valItem, _index ) => {
                                return (
                                    <p key={ _index } className='ui-table-cell-view-simple-select__tooltip__value'>
                                        { _valItem }
                                    </p>
                                );
                            } )
                        }
                    </ReactTooltip>
                ) : null
            }
        </div>
    );
};

// display name
simpleText.displayName = 'table.cellViews.simpleText';

// default values
simpleText.defaultValues = {
    uniqId: shortid.generate(),
    value: [],
    maxDisplayValues: undefined,
    isSearchable: false,
    searchQuery: '',
    columnType: DATA_TYPES.TEXT,
    isActionable: false,
    onClick: noop,
    tooltipBackgroundColor: null,
    tooltipTextColor: null,
    addTooltipCustomClass: false
};
